import React from 'react';
import katex from 'katex';
import 'katex/dist/katex.min.css';
import CodeBlock from './CodeBlock';

interface LaTeXBlockProps {
    children: string;
    index?: number;
}

const LaTeXBlock: React.FC<LaTeXBlockProps> = ({ children, index = 0 }) => {
    try {
        const html = katex.renderToString(String(children).trim(), {
            throwOnError: true,
            displayMode: true,
            trust: true,
            strict: false
        });

            return (
                <div className="overflow-x-auto max-w-full" style={{ overflowY: 'hidden' }}>
                    <div dangerouslySetInnerHTML={{ __html: html }}/>
                </div>
            );
    } catch (error) {
        console.error('LaTeX rendering error:', error);
        return (
            <CodeBlock
                language="latex"
                index={index}
            >
                {children}
            </CodeBlock>
        );
    }
};

export default LaTeXBlock;